module.exports = __webpack_public_path__ + "img/badge-expertise-gold-darkbg.6f6c8528.svg";